import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText } from '../../../../../utils/utility';
import { useParams } from 'react-router';

export default function financialsColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.id;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let columnValueData = null;
            let columnValue = null;
            let isDisabled = false;
            let alignItem = 'left';
            if (columnDataType === "string") {
                if (columnId === "paymentStatus") {
                    columnValue = getStatusDescriptionFromStatusValue(order.paymentStatus) || "";
                }
                if (columnId === "paymentDate") {
                    columnValue = getDateWithSpecificFormat(order.paymentDate);
                }
                if (columnId === "amount") {
                    columnValue = order.customerAmount;
                }
                if (columnId === "invoiceAndPaymentInstruction") {
                    columnValue = "download";
                }
                if (columnId === "paymentType") {
                    columnValue = order.paymentType;
                }
                if (columnId === "hpPONo") {
                    columnValue = order.hpPONo;
                }
                if (columnId === "customerInvoiceNo") {
                    columnValue = order.customerInvoiceNo;
                }
                if (columnId === "customerPONo") {
                    columnValue = order.customerPONo;
                }
                if (columnId === "hpInvoiceNo") {
                    columnValue = order.hpInvoiceNo;
                }
            }
            else if (columnDataType === "input") {
                if (columnId === "hpPONo") {
                    columnValue = order.hpPONo;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = order.customerAmount === 0 && order.paymentType === "No Customer Payment" ? true : false;
                }
                if (columnId === "customerInvoiceNo") {
                    columnValue = order.customerInvoiceNo;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = order.customerAmount === 0 && order.paymentType === "No Customer Payment" ? true : false;
                }
                if (columnId === "customerPONo") {
                    columnValue = order.customerPONo;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = order.customerAmount === 0 && order.paymentType === "No Customer Payment" ? true : false;
                }
                if (columnId === "hpInvoiceNo") {
                    columnValue = order.hpInvoiceNo;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = order.customerAmount === 0 && order.paymentType === "No Customer Payment" ? true : false;
                }
            }

            if (columnDataType === "icon") {
                if (columnId === "invoiceAndPaymentInstruction") {
                    if(order.customerAmount === 0){
                        columnDataType = "string";
                        isDisabled = true;
                    }
                    else {
                        columnValue = "download";
                        alignItem = 'center';
                    }
                    
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    alignItem: alignItem,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, rowId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
